import React from "react";
import { useCurrency } from "../../../context-v2/CurrencyContext";
import { DashboardVisibilityIcon, CheckmarkIcon, ArrowLeftIcon } from "../icons/OnboardingIcons";

const PlanSelectionStep = ({ formData, updateFormData, onNext, onBack }) => {
  const { formatAmount } = useCurrency();
  const [availablePlans] = React.useState([]); // This will be populated from API

  const handleComplete = () => {
    if (!formData.selectedPlan && availablePlans.length > 0) {
      alert("Please select a subscription plan");
      return;
    }
    onNext();
  };

  return (
    <div className="v2-plan-selection-step">
      <div className="v2-step-header">
        <div className="v2-step-icon v2-step-icon--red">
          <DashboardVisibilityIcon />
        </div>
        <h2 className="v2-step-title">Select Subscription Plan</h2>
      </div>

      <p className="v2-step-description">Choose a plan for the gym owner</p>

      <div className="v2-plan-selection__content">
        {availablePlans.length === 0 ? (
          <div className="v2-plan-selection__empty">
            <div className="v2-plan-selection__empty-icon">
              <DashboardVisibilityIcon size={64} />
            </div>
            <h3 className="v2-plan-selection__empty-title">No Plans Available</h3>
            <p className="v2-plan-selection__empty-text">
              Please create subscription plans in Phase 1 first
            </p>
          </div>
        ) : (
          <div className="v2-plan-selection__grid">
            {availablePlans.map((plan) => (
              <button
                key={plan.id}
                className={`v2-plan-card ${
                  formData.selectedPlan === plan.id
                    ? "v2-plan-card--selected"
                    : ""
                }`}
                onClick={() => updateFormData("selectedPlan", plan.id)}
              >
                <div className="v2-plan-card__header">
                  <h4 className="v2-plan-card__name">{plan.name}</h4>
                  <div className="v2-plan-card__price">
                    {formatAmount(plan.price)}
                    <span className="v2-plan-card__duration">/{plan.duration}</span>
                  </div>
                </div>
                <div className="v2-plan-card__description">
                  {plan.description}
                </div>
                <div className="v2-plan-card__features">
                  {plan.features?.slice(0, 5).map((feature, index) => (
                    <div key={index} className="v2-plan-card__feature">
                      <CheckmarkIcon />
                      {feature}
                    </div>
                  ))}
                </div>
                {formData.selectedPlan === plan.id && (
                  <div className="v2-plan-card__selected-badge">
                    <CheckmarkIcon />
                    Selected
                  </div>
                )}
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Actions */}
      <div className="v2-step-actions">
        <button className="v2-btn v2-btn--back" onClick={onBack}>
          <ArrowLeftIcon />
          Back
        </button>
        <button
          className="v2-btn v2-btn--primary v2-btn--complete"
          onClick={handleComplete}
        >
          <CheckmarkIcon />
          Complete Onboarding
        </button>
      </div>
    </div>
  );
};

export default PlanSelectionStep;
